module.exports = __webpack_public_path__ + "static/img/news_img_1.0adbf49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/news_img_1.jpg
// module id = gUOz
// module chunks = 0